<script>

export let expanded = false;

import { loans } from './stores.js';
import { calculateCurrentLoanAmount, calculateFullCostByLoan, calculateFullCost
} from './loancalc.js'

loans.subscribe(l => {
    window.localStorage.setItem('loans', JSON.stringify(l));
})

let amount
let rate
let payment

function toggleLoans() {
    expanded = !expanded;
}

function removeLoan(i) {
    if (confirm("Really delete your loan?")) {
        $loans.splice(i, 1)
        loans.set($loans)
    }
}

</script>

<div>
    {#if expanded}
        {#if $loans.length}
            {#each $loans as loan, i}
				<div class="card mt-3">
				  <header class="card-header">
					<p class="card-header-title">Loan</p>
				  </header>
				  <div class="card-content">
					<div class="content">
						<table>
							<tr><td>Rate</td> <td>{loan.rate}</td></tr>
							<tr><td>Payment</td> <td>{loan.payment}</td></tr>
							<tr><td>Amount at Start</td> <td>{loan.amount}</td></tr>
							<tr><td>Current Amount</td> <td>{ calculateCurrentLoanAmount(loan.amount, loan.payment, loan.rate, loan.created_at) }</td></tr>
							<tr><td>Full Amount You'll Pay</td> <td>{ calculateFullCostByLoan(loan) }</td></tr>
						</table>
					</div>
				  </div>
				  <footer class="card-footer">
					<a href="" on:click|preventDefault="{() => removeLoan(i)}" class="card-footer-item">Delete</a>
					<a href="" on:click|preventDefault="{toggleLoans}" class="card-footer-item">Close</a>
				  </footer>
				</div>
            {/each}
        {/if}
    {:else}
        <div class="columns mt-2 is-mobile is-centered">
            <div class="column is-narrow">
                <button class="button is-text" on:click="{toggleLoans}">View Loan</button>
            </div>
        </div>
    {/if}
</div>

<style></style>
